module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-ties.05766acc.png";